import { useEffect, useRef, useState } from "react";
import { namedChainsApi, type NamedChainRow } from "./api/named-chains-client";

interface IdentityPanelProps {
  chain: NamedChainRow;
  onUpdate: (updated: NamedChainRow) => void;
}

export function IdentityPanel({ chain, onUpdate }: IdentityPanelProps) {
  const [name, setName] = useState(chain.name);
  const [description, setDescription] = useState(chain.description);

  const isFirstRender = useRef(true);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(async () => {
      const updated = await namedChainsApi.update(chain.id, { name, description });
      onUpdate(updated);
    }, 800);
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    // onUpdate intentionally omitted from deps — vi.fn() identity changes
    // re-trigger debounce. Parent must wrap in useCallback if it cares.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [name, description, chain.id]);

  return (
    <div className="rb-section">
      <h2 className="rb-section-title">Identity Panel</h2>

      <div className="rb-row">
        <label htmlFor="nc-identity-name" className="rb-label">
          Name
        </label>
        <input
          id="nc-identity-name"
          className="rb-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div className="rb-row">
        <label htmlFor="nc-identity-description" className="rb-label">
          Description
        </label>
        <textarea
          id="nc-identity-description"
          className="rb-input"
          value={description}
          rows={3}
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
    </div>
  );
}
